<script lang="ts">
  import CornerIcon from '$icons/CornerIcon.svelte';
</script>

<div class="flex w-full justify-center">
  <div class="w-full">
    <div class="rounded-2xs md:border-gray-dark-6 md:p-3xs w-full border border-transparent p-0">
      <div class="rounded-2xs md:border-gray-dark-2 md:p-md w-full border border-transparent">
        <!-- Details -->
        <div
          class="gap-x-lg rounded-3xs border-gray-dark-1 bg-gray-dark-1 p-2xs relative flex w-full flex-col gap-y-3 border md:flex-row"
        >
          <CornerIcon class="text-gray-dark-12 absolute right-0 top-0 -m-0.5" />
          <CornerIcon class="text-gray-dark-12 absolute bottom-0 left-0 -m-0.5 rotate-180 " />
          <div class="flex justify-between">
            <!-- Avatar skeleton -->
            <div class="bg-gray-dark-4 h-[88px] w-[88px] rounded" />
          </div>
          <div class="flex flex-1 flex-col items-start">
            <!-- Name skeleton -->
            <div class="bg-gray-dark-4 h-8 w-48 rounded" />
            <!-- Username skeleton -->
            <div class="bg-gray-dark-4 mt-2 h-4 w-32 rounded" />
          </div>
        </div>
        <!-- Position/Location/Languages -->
        <div class="mt-md gap-y-md text-gray-dark-11 flex flex-wrap items-center gap-x-4">
          <!-- Position skeleton -->
          <div class="bg-gray-dark-4 h-4 w-48 rounded" />
          <!-- Location skeleton -->
          <div class="bg-gray-dark-4 h-4 w-32 rounded" />
          <!-- Languages skeleton -->
          <div class="bg-gray-dark-4 h-4 w-24 rounded" />
        </div>
        <!-- Socials -->
        <div class="mt-md gap-xl flex flex-col items-center justify-between md:flex-row-reverse">
          <!-- Edit/Message button skeleton -->
          <div class="bg-gray-dark-4 h-9 w-32 rounded" />
          <!-- Social icons skeleton -->
          <div class="flex items-center gap-x-2">
            {#each Array(4) as _}
              <div class="bg-gray-dark-4 h-8 w-8 rounded" />
            {/each}
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs skeleton -->
    <div class="my-6 w-full">
      <div class="flex gap-4">
        {#each Array(2) as _}
          <div class="bg-gray-dark-4 h-8 w-24 rounded" />
        {/each}
      </div>
    </div>
    <!-- Content skeleton -->
    <div class="space-y-4">
      {#each Array(3) as _}
        <div class="bg-gray-dark-4 h-24 w-full rounded" />
      {/each}
    </div>
  </div>
</div>
